"use strict";var e=require("styled-components").css`
    padding: 12px 20px;
    margin: 0;
    border-radius: ${({theme:e})=>e.borderRadiuses.small};
    cursor: pointer;

    &[data-active='true'],
    &:hover,
    &:focus,
    &:active {
        background: ${({theme:e})=>e.colors.primary.light};
    }

    &[aria-selected='true'] {
        background: ${({theme:e})=>e.colors.primary.default};

        > * {
            color: ${({theme:e})=>e.colors.common.light};
        }
    }

    > * {
        margin: 0;
        line-height: 1em;
        color: ${({theme:e})=>e.colors.common.dark};
    }

    &[aria-disabled='true'] {
        pointer-events: none;
        p {
            color: ${({theme:e})=>e.colors.grey[400]};
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
